import createReactClass from "create-react-class";

export default function(dependencies) {

    const Tabs = createReactClass({
        elements: [],
        render() {
            var field = this.props.field;
            var config = field.config;
            var alerts = config.alerts || [];

            var display = config.options.length <= 1 ? "none" : "";
            return <div style={{display: display}} >
                <div className="lz-input-wrapper">
                    <label>{config.label}</label>
                    <span className="lz-extratext">{field.config.tinyLabel}</span>
                </div>
                <div className="leazard-tabs" >
                    <div className="lz-table lz-table-middle" >
                        {config.options.map((tabOption, index) => this.makeTab(tabOption, config.options.length, index) )}
                    </div>
                </div>
                {alerts.map((Alert, index) => {
                    return <Alert key={index} {...this.props} isTabSelected={this.isTabSelected} selectTab={this.selectTab} />
                })}
            </div>;
        },
        componentDidMount() {
            this.props.sharedScope.selectTab = this.sharedSelectTab;
        },
        isTabSelected(tabId) {
            return this.props.field.state.value === tabId;
        },
        makeTab(tabOption, numberOfTabs, index) {
            var {value, display} = tabOption;
            return <div className={"lz-table-cell lz-cell-1-" + numberOfTabs} key={value} ref={(el) => this.elements[index] = el} onClick={this.selectTab(value)} onKeyDown={this.onKey(numberOfTabs, index)}>
                <div className="lz-tab">
                    <input type="radio" name="tab" checked={this.isTabSelected(value)} readOnly />
                    <label>
                        <i className="fa fa-check" aria-hidden="true"></i> {display}
                    </label>
                </div>
            </div>;
        },
        onKey(numberOfTabs, index){
            return (event) => {
                
                const changeFocus = (next) => {
                    const {options} = this.props.field.config;
                    this.elements[next].focus();
                    this.sharedSelectTab(options[next].value);
                }

                let next = index;
                if(event.key === "ArrowRight"){
                    next = index === numberOfTabs -1 ? 0 : ++index;
                    changeFocus(next);
                }else if(event.key === "ArrowLeft"){
                    next = index === 0 ? numberOfTabs -1 : --index;
                    changeFocus(next);
                }

            }
        },
        selectTab(value) {
            return this.sharedSelectTab.bind(this, value);
        },
        sharedSelectTab(value) {
            this.props.field.state.value = value;
            this.forceUpdate();
            this.props.onUpdate();
        }
    });


    return {
        html: Tabs,
        config: {
            behaviour: "tabs",
            defaultValue: null,
            defaultValueBehaviour: "first"
        }
    };

};
